import axios from 'axios';
import tools from './tools';

axios.defaults.withCredentials = false;

class Request {
  constructor() {
    this.Instance.interceptors.response.use(
      (resp) => resp.data,
      (err) => {
        throw err;
      },
    );

    this.Instance.interceptors.request.use((res) => {
      res.headers.common.userId = tools.getQueryString('userId') || localStorage.getItem('userId') || '';
      res.headers.common.token = tools.getQueryString('token') || localStorage.getItem('token') || '';
      return res;
    });
  }

  Instance = axios.create({
    timeout: 10000, // 10s超时
    responseType: 'json',
    headers: {},
    transformResponse: [(data) => data],
  })

  /**
   * get 方式发送请求
   * @param url 地址
   * @param data 数据
   */
  get({ url, data = {} }) {
    return this.Instance.get(url, {
      params: data,
    });
  }

  /**
   * post form 方式发送请求
   * @param url 地址
   * @param data 数据
   */
  post({ url, data }) {
    return this.Instance.post(url, data);
  }

  /**
   * 以json的形式发送请求
   * @param url 地址
   * @param data 数据
   */
  postJson({ url, data }) {
    return this.Instance.post(url, data);
  }

  /**
   * 获取二进制数据流 - get
   * @param url
   * @param data
   * @param responseType
   * @returns {AxiosPromise}
   */
  static getBoldData(url, data, responseType = 'blob') {
    return axios({
      url, params: data, method: 'GET', responseType,
    });
  }

  /**
   * 获取二进制数据流 - post
   * @param url
   * @param data
   * @param responseType
   * @returns {AxiosPromise}
   */
  postBoldData(url, data, responseType = 'blob') {
    return this.Instance({
      url, data, method: 'post', responseType,
    });
  }
}

export default new Request();
